<script setup lang="ts">
import { BadgeColor } from '../../badge/badge.constants';
import Icon from '../../icon/icon.vue';
import { IconName, IconSize } from '../../icon/icon.constants';

type Props = {
  /** Status text, displayed uppercase. */
  label: string;
  /** Semantic status color, mapped to a container/on-container token pair. */
  color?: BadgeColor;
  /** Disables the trigger. */
  disabled?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  color: BadgeColor.NEUTRAL,
});

const colorClass: Record<BadgeColor, string> = {
  [BadgeColor.INFO]: 'bg-info-container text-on-info-container',
  [BadgeColor.NEUTRAL]: 'bg-neutral-container text-on-neutral-container',
  [BadgeColor.SUCCESS]: 'bg-success-container text-on-success-container',
  [BadgeColor.WARNING]: 'bg-warning-container text-on-warning-container',
  [BadgeColor.ERROR]: 'bg-error-container text-on-error-container',
};
</script>

<template>
  <button
    type="button"
    :disabled="props.disabled"
    class="text-caption inline-flex w-fit items-center gap-md rounded-lg px-xl py-sm uppercase disabled:opacity-60"
    :class="colorClass[props.color]"
  >
    {{ props.label }}
    <Icon :name="IconName.CARET_DOWN" :size="IconSize.SM" />
  </button>
</template>
